export default __webpack_public_path__ + "static/media/big.02671b00.png";